import React from 'react';
import { useTranslation } from 'react-i18next';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import ActionBarB18Link from '../../_partials/items/ActionBarB18Link';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import { ReferralType } from '@wix/da-bi/pkg/constants';
export const LoginToDownloadButton = ({ deviation: { deviationId, isDownloadable, isPurchasable }, className })=>{
    const { t } = useTranslation();
    const { isLoggedIn, restrictToLoggedIn } = useRestrictToLoggedIn();
    if (!isDownloadable && !isPurchasable) {
        return null;
    }
    return isLoggedIn ? null : /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        popoverWrapperClassName: className
    }, /*#__PURE__*/ React.createElement(ActionBarB18Link, {
        onClick: restrictToLoggedIn(ReferralType.ANON_DOWNLOAD),
        biData: PureBiData({
            evid: 350,
            ispaiddownload: isPurchasable ? 1 : 0,
            deviationid: deviationId,
            sectionname: 'action_bar'
        })
    }, t('actionbar.download.mustLogIn')));
};
LoginToDownloadButton.displayName = 'LoginToDownloadButton';
export default LoginToDownloadButton;
